/**
 * =============================================================================
 * back-in-stock.js 
 * =============================================================================
 * Helper for custom BIS integration
 * =============================================================================
 */

var BackInStock = {
  data: {
    selectors: {
      button: ".product-back-in-stock-form button",
    }
  },

  onReady: function() {
    document.querySelectorAll(this.data.selectors.button).forEach(e => {
      e.addEventListener("click", this.onBISFormSubmitted.bind(this));
    });
  },

  onBISFormSubmitted: function(e) {
    e.preventDefault();
    let bisContainer = e.target.closest(".product-back-in-stock-form");
    let productForm = MP.Extensions.ProductFormManager.forms[e.target.closest(".product-container").id];

    let email = bisContainer.querySelector("input[type='email']").value;
    let acceptsMarketing = bisContainer.querySelector("input[type='checkbox']").checked;
    let variantId = productForm.variantStateManager.currentVariant.id;
    let productId = productForm.product.id;
    let attributes = { accepts_marketing: acceptsMarketing };
    if(!email || !variantId || !productId){
      console.error("[B-I-S] Failed to get necessary BIS data");  
    }

    console.log('sending');

    BIS.create(email, variantId, productId, attributes).then(resp => {
      this.handleBISResponse(resp, bisContainer); 
    });
  },

  handleBISResponse: function(resp, bisContainer) {
    let bisResponseContainer = bisContainer.querySelector(".product-back-in-stock-response");
    switch(resp.status){
      case "Error":
        bisResponseContainer.classList.replace("alert-success", "alert-danger");
        let errors = [];
        Object.keys(resp.errors).forEach(function(k){
          errors = errors.concat(resp.errors[k]);
        });
        bisResponseContainer.innerText = errors.join(', ');
        break;
      case "OK":
        bisResponseContainer.classList.replace("alert-danger", "alert-success");
        bisResponseContainer.innerText = resp.message;
        bisContainer.querySelector("button").disabled = true;
        bisContainer.querySelector("button").innerHTML = "Registered!";
        break;
    }
    bisResponseContainer.classList.remove("d-none");
  }
};

export default BackInStock;